module.exports = __webpack_public_path__ + "img/pro_five_7.7cca8f99.jpg";